{
  "name": "aline",
  "version": "2.10",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=dev --proxy-config src/proxy.conf.json",
    "start-legacy": "export NODE_OPTIONS=--openssl-legacy-provider;ng serve --configuration=dev --proxy-config src/proxy.conf.json",
    "build": "ng build",
    "beta-build": "ng build --base-href=/ --configuration=beta",
    "test-build": "ng build --base-href=/ --configuration=staging",
    "prod-build": "ng build --base-href=/ --configuration=production",
    "docker-build": "ng build --base-href=/ --configuration=docker",
    "test": "ng test",
    "lint": "ng lint --fix",
    "prettify": "prettier --write '**/*.+(ts|css|html)'",
    "check-prettier": "prettier --check '**/*.+(ts|css|html)'",
    "e2e": "ng e2e",
    "compodoc": "npx compodoc -p src/tsconfig.app.json",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "cypress:regression": "cypress run --spec \"cypress/e2e/regression/**/*.spec.ts\"",
    "zephyr:report": "node scripts/zephyr/report-to-zephyr.mjs --results cypress/results/zephyr-run.json",
    "prepare": "husky install"
  },
  "lint-staged": {
    "**/*.+(ts|css|html)": [
      "eslint --fix",
      "prettier --write"
    ]
  },
  "private": true,
  "overrides": {
    "@emnapi/core": "1.11.3",
    "@emnapi/runtime": "1.11.3",
    "@emnapi/wasi-threads": "1.2.3"
  },
  "dependencies": {
    "@angular/animations": "21.2.12",
    "@angular/common": "21.2.12",
    "@angular/compiler": "21.2.12",
    "@angular/core": "21.2.12",
    "@angular/forms": "21.2.12",
    "@angular/platform-browser": "21.2.12",
    "@angular/platform-browser-dynamic": "21.2.12",
    "@angular/router": "21.2.12",
    "@auth0/angular-jwt": "5.2.0",
    "@compodoc/compodoc": "1.2.1",
    "@fullcalendar/angular": "6.1.20",
    "@fullcalendar/core": "6.1.20",
    "@fullcalendar/daygrid": "6.1.20",
    "@fullcalendar/interaction": "6.1.20",
    "@fullcalendar/list": "6.1.20",
    "@fullcalendar/resource-timegrid": "6.1.20",
    "@fullcalendar/resource-timeline": "6.1.20",
    "@fullcalendar/scrollgrid": "6.1.20",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@pdf-lib/fontkit": "^1.1.1",
    "@primeng/themes": "^21.0.4",
    "@primeuix/utils": "0.7.1",
    "@tabler/icons-webfont": "3.31.0",
    "chart.js": "^4.4.1",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "jspdf": "^2.5.1",
    "jspdf-autotable": "^3.7.1",
    "marked": "^18.0.7",
    "ng2-pdf-viewer": "^9.1.5",
    "ngx-json-viewer": "^3.2.1",
    "pdf-encrypt": "^1.0.1",
    "pdf-lib": "^1.17.1",
    "primeflex": "4.0.0",
    "primeicons": "7.0.0",
    "primeng": "21.1.6",
    "print-js": "^1.6.0",
    "rxjs": "7.8.2",
    "tslib": "2.8.1",
    "xlsx": "^0.18.0",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "19.8.1",
    "@angular-eslint/eslint-plugin": "19.8.1",
    "@angular-eslint/eslint-plugin-template": "19.8.1",
    "@angular-eslint/schematics": "19.8.1",
    "@angular-eslint/template-parser": "19.8.1",
    "@angular/build": "^21.2.10",
    "@angular/cli": "21.2.10",
    "@angular/compiler-cli": "21.2.12",
    "@cypress/schematic": "^1.5.3",
    "@emnapi/core": "1.11.3",
    "@emnapi/runtime": "1.11.3",
    "@types/jasmine": "^3.6.11",
    "@types/node": "24.1.0",
    "@typescript-eslint/eslint-plugin": "8.58.0",
    "@typescript-eslint/parser": "8.58.0",
    "cypress": "^15.14.2",
    "cypress-multi-reporters": "^2.0.5",
    "cypress-real-events": "^1.15.0",
    "eslint": "9.39.4",
    "eslint-config-prettier": "9.1.2",
    "eslint-plugin-prettier": "5.5.5",
    "eslint-plugin-unused-imports": "4.4.1",
    "husky": "^8.0.0",
    "jasmine-core": "^5.0.1",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "lint-staged": "^13.0.3",
    "mocha-junit-reporter": "^2.2.1",
    "mochawesome": "^7.1.4",
    "mochawesome-merge": "^5.1.1",
    "mochawesome-report-generator": "^6.3.2",
    "mysql2": "^3.24.6",
    "ngx-translate-testing": "7.0.0",
    "prettier": "3.8.1",
    "prettier-eslint": "16.4.2",
    "protractor": "~7.0.0",
    "ts-node": "10.9.2",
    "typescript": "5.9.3"
  }
}
